module.exports = __webpack_public_path__ + "img/retail-purple.220f79b9.png";